import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 22h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 10h3m7 0h-1.343", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 15v7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "WineOff";
const WineOff = memo(themed(Icon));
export {
  WineOff
};
//# sourceMappingURL=wine-off.js.map
